import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";

import { useAuth } from "@/auth/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CreateTenant from "@/pages/CreateTenant";
import TenantDetail from "@/pages/TenantDetail";

export default function App() {
  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <NavBar />
      <main style={{ flex: 1, padding: "24px", maxWidth: 1200, width: "100%", margin: "0 auto" }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<RequireAuth><Dashboard /></RequireAuth>} />
          <Route path="/tenants/new" element={<RequireAuth><CreateTenant /></RequireAuth>} />
          <Route path="/tenants/:tenantId" element={<RequireAuth><TenantDetail /></RequireAuth>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <footer style={{ padding: "12px 24px", borderTop: "1px solid var(--color-border)", color: "var(--color-muted)", fontSize: 12 }}>
        Mattermost B-Hybrid Platform · {new Date().getFullYear()}
      </footer>
    </div>
  );
}

function NavBar() {
  const { isAuthenticated, email, signOut } = useAuth();

  return (
    <nav style={{
      display: "flex",
      alignItems: "center",
      gap: 16,
      padding: "12px 24px",
      borderBottom: "1px solid var(--color-border)",
      background: "white",
    }}>
      <Link to="/" style={{ fontWeight: 700, fontSize: 16 }}>Mattermost Admin</Link>
      <div style={{ flex: 1 }} />
      {isAuthenticated && (
        <>
          <span className="muted" style={{ fontSize: 13 }}>{email}</span>
          <button onClick={signOut}>Sign out</button>
        </>
      )}
    </nav>
  );
}

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { loading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading) return <p className="muted">Loading...</p>;
  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location }} />;
  return <>{children}</>;
}
